<template>
  <v-container fluid class="pa-4">
    <v-row>
      <v-col cols="12">
        <v-alert :value="alert" type="success">Başarıyla kaydedildi.</v-alert>

        <v-card>
          <v-card-title class="pb-2">
            <v-icon left>business</v-icon>
            {{ isEditMode ? 'Şirket Düzenle' : 'Yeni Şirket Ekle' }}
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="model.name"
                    label="Şirket Adı *"
                    outlined
                    dense
                    :rules="requiredRules"
                  />
                </v-col>
              </v-row>

              <v-row class="mt-4">
                <v-col cols="12">
                  <v-btn color="success" @click="save" :loading="saving" :disabled="!valid" class="mr-2">
                    <v-icon left>save</v-icon>
                    Kaydet
                  </v-btn>
                  <v-btn color="grey" text @click="goBack">
                    <v-icon left>arrow_back</v-icon>
                    Geri Dön
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import companiesApi from '@/api/companies';

export default {
  data() {
    return {
      valid: false,
      alert: false,
      saving: false,
      model: {
        id: null,
        name: '',
      },
      requiredRules: [
        (v) => !!(v && String(v).trim()) || 'Bu alan zorunludur',
      ],
    };
  },
  computed: {
    isEditMode() {
      return !!this.$route.params.id;
    },
  },
  methods: {
    goBack() {
      this.$router.push('/admin/companies');
    },
    async load() {
      if (!this.isEditMode) return;
      try {
        const res = await companiesApi.getCompany(this.$route.params.id);
        this.model = Object.assign({}, this.model, res && res.data ? res.data : {});
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Şirket bilgisi alınamadı.';
        this.goBack();
      }
    },
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      try {
        const payload = { name: String(this.model.name || '').trim() };
        if (this.isEditMode) {
          await companiesApi.putCompany(this.$route.params.id, payload);
        } else {
          await companiesApi.postCompany(payload);
        }
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
          this.goBack();
        }, 1200);
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Kaydetme sırasında hata oluştu.';
      } finally {
        this.saving = false;
      }
    },
  },
  mounted() {
    this.load();
  },
};
</script>

